<template>
    <div class="app-aside">
        <el-aside width="auto">
            <el-button class="btn-collapse" type="primary" size="large" @click="isCollapse = !isCollapse" :class="{'collapsed': isCollapse}">
                <i class="nucfont" :class="isCollapse ? 'inuc-menu-fold': 'inuc-menu-unfold'"></i>
            </el-button>

            <el-menu class="aside-menu"
                     :default-active="activeMenu"
                     :router="router"
                     :collapse="isCollapse"
                     :background-color="themeOption.backgroundColor"
                     :text-color="themeOption.textColor"
                     :active-text-color="themeOption.activeTextColor"
                     unique-opened
                     @select="onMenuSelect">
                <template v-for="item in menuData">

                    <el-menu-item v-if="!item.children.length" :index="item.path || '0'" :key="item.id">
                        <i class="nucfont" :class="item.iconClass ||'nucfont inuc-theory' "></i>
                        <span class="menu-title" slot="title"> {{item.name}}</span>
                    </el-menu-item>

                    <el-submenu v-else :index="item.id+''" :key="item.id">
                        <template slot="title">
                            <i class="nucfont" :class="item.iconClass"></i>
                            <span class="menu-title" slot="title"> {{item.name}}</span>
                        </template>
                        <el-menu-item v-for="child in item.children" :index="child.path" :key="child.id">
                            <span class="menu-subtitle">{{child.name}}</span>
                        </el-menu-item>
                    </el-submenu>

                </template>

            </el-menu>
        </el-aside>
    </div>
</template>
<script>

    /**
     *  1.25 菜单跳转改用router的方式，只需设置菜单的index为当前路由的path
     */
    import {Storage, Ticket} from '@/utils';
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                isCollapse: false,
                router: true,
                activeMenu: '',
                menuData: {},
            }
        },
        computed: {
            ...mapGetters([
                'appTheme',
                'documentSize'
            ]),
            themeOption() {
                if (this.appTheme === 0) {
                    return {
                        backgroundColor: '#3b3e47',
                        textColor: '#fff',
                        activeTextColor: '#188ae2'
                    }
                } else {
                    return {
                        backgroundColor: '',
                        textColor: '',
                        activeTextColor: ''
                    }
                }
            }
        },
        created() {
            this.menuData = Storage.get('menu');

            if (!this.menuData) {
                window.location.href = "/login";
            }

            this.changeActiveMenu();
        },
        watch: {
            documentSize: {
                handler(v) {
                    let width = v.width

                    this.isCollapse = (width <= 990)
                },
                immediate: true
            },
            $route(to, from) {
                this.changeActiveMenu();
            }
        },
        methods: {
            onMenuSelect(index, path) {

                let piece = this.$route.path.split('/');

                return;

                if (piece.length >= 3) {
                    this.router = false;
                    this.$router.replace('/'+piece[1]);
                    this.router = true;
                }

            },
            changeActiveMenu() {
                //let path = this.$route.path.substring(1);

                this.activeMenu = this.$route.path;
            },
        },
    }
</script>
<style lang="scss">
    @import '../../style/const';

    //菜单文字距图标的距离
    $span-ml: 15px;

    .app-aside {
        float: left;
        height: 100%;
        padding-top: $h-header;
        @include scrollbar();

        .el-aside {
            display: flex;
            flex-direction: column;
            height: 100%;
            color: #333;
            background-color: #fff;
            box-shadow: 1px 0 2px 1px rgba(0, 0, 0, 0.08);
            overflow: inherit;

            //ul
            .aside-menu {
                width: $w-aside;
                height: 100%;
                border: none;
                overflow: auto;
                @media screen and (max-width: 1367px) {
                    width: 190px;
                    overflow-x: hidden;
                }
            }

            .menu-title {
                margin-left: $span-ml;
            }

            .menu-subtitle {
                padding-left: $span-ml;
            }

            //ul折叠
            .el-menu--collapse {
                width: 64px;
                //overflow: inherit;
                overflow: auto;
                .el-tooltip, .el-submenu__title {
                    text-align: center;
                }

                > .el-menu-item span,
                > .el-submenu > .el-submenu__title span {
                    display: none;
                }
            }

            // 激活菜单样式
            .el-menu-item:focus {
                background-color: inherit;
            }

        }

        .btn-collapse {
            width: 100%;
            border: 0;
            border-radius: 0;

            > span {
                display: block;
            }

            .nucfont {
                font-size: 18px;
            }
        }

    }

    .lang-pt-BR {
        .app-aside {
            .aside-menu {
                width: 270px;
            }
        }
        .el-submenu__title {
            padding: 0 10px;
        }
        .app-aside .el-aside .menu-title {
            margin-left: 10px;
        }
        .el-submenu__title, .el-menu-item {
            font-size: 13px;
        }
    }
</style>
